// extracted by mini-css-extract-plugin
module.exports = {"xs":"100%","xsMax":"575px","sm":"576px","smMax":"767px","md":"768px","mdMax":"991px","lg":"992px","lgMax":"1199px","xl":"1200px","xlMax":"1599px","xxl":"1600px"};